import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "submitBtn"]

  toggleSubmit() {
    this.submitBtnTarget.disabled = !this.checkboxTarget.checked
  }
}
